import {
  scaleLinear,
} from 'd3-scale';
import {
  ILoadable,
  LoadableStatus,
} from '../../Utils';
import {
  IAssignRadiusOutput,
  IAssignYOutput,
  IProcessedNodePrecursor,
  ValueGetter,
} from './Utils';

const getRadiusAssigner =
  (minRadius: number, maxRadius: number) => (
      getValue: ValueGetter,
      withCoordsStatus: ILoadable<IAssignYOutput>,
    ): ILoadable<IAssignRadiusOutput> => {

  let result: ILoadable<IAssignRadiusOutput>;
  if (withCoordsStatus.status === LoadableStatus.Initial) {
    result = {status: LoadableStatus.Initial};
  } else if (withCoordsStatus.status === LoadableStatus.Loading) {
    result = {status: LoadableStatus.Loading};
  } else if (withCoordsStatus.status === LoadableStatus.NotPresent) {
    result = {status: LoadableStatus.NotPresent};
  } else {
    const {
      data: {
        nodes: withCoords,
        xAxisMin, xAxisMax, xScale,
        yAxisMin, yAxisMax, yScale,
        yAverage,
      },
    } = withCoordsStatus;

    const allValues = withCoords.map(getValue);

    const maxValue = Math.max(...allValues);
    const minValue = Math.min(...allValues);
    const radiusScale = scaleLinear<number, number>()
                          .domain([minValue, maxValue])
                          .range([minRadius, maxRadius]);
    const withRadius: IProcessedNodePrecursor[] = withCoords.map(datum => {
      const value = getValue(datum);
      return {
        ...datum,
        radius: radiusScale(value),
      };
    });
    result = {
      status: LoadableStatus.Present,
      data: {
        nodes: withRadius,
        xAxisMin, xAxisMax, xScale,
        yAxisMin, yAxisMax, yScale,
        yAverage,
      },
    };
  }
  return result;
};

export default getRadiusAssigner;
